import script from "./wz_list.vue?vue&type=script&setup=true&lang=js"
export * from "./wz_list.vue?vue&type=script&setup=true&lang=js"

import "./wz_list.vue?vue&type=style&index=0&id=fed511f2&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fed511f2"]])

export default __exports__